import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function Analysis({
  title = "",
  info = [],
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  const total = info.total || {};
  const totalb = info.totalb || {};
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(17, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(17, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow className="odd gradeX">
                      <TableCell>{total.agency?.name}</TableCell>
                      <TableCell
                        colSpan={6}
                        align="center"
                        className="separator-year"
                      >
                        <b>{total.date1}</b>
                      </TableCell>
                      <TableCell colSpan={6} align="center">
                        <b>{total.date2}</b>
                      </TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>Term</TableCell>
                      <TableCell>
                        <strong>Premium %</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Count %</strong>
                      </TableCell>
                      <TableCell>
                        <strong>#Pol</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Net Premium</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Policy Fee</strong>
                      </TableCell>
                      <TableCell className="separator-year">
                        <strong>Total</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Premium %</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Count %</strong>
                      </TableCell>
                      <TableCell>
                        <strong>#Pol</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Net Premium</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Policy Fee</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Total</strong>
                      </TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>Short Term</TableCell>
                      <TableCell>{fmtMoney(total.short?.net_perc)}%</TableCell>
                      <TableCell>
                        {fmtMoney(total.short?.count_perc)}%
                      </TableCell>
                      <TableCell>{total.short?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(total.short?.net)}</TableCell>
                      <TableCell>
                        ${fmtMoney(total.short?.policy_fee)}
                      </TableCell>
                      <TableCell className="separator-year">
                        ${fmtMoney(total.short?.total)}
                      </TableCell>
                      <TableCell>{fmtMoney(totalb.short?.net_perc)}%</TableCell>
                      <TableCell>
                        {fmtMoney(totalb.short?.count_perc)}%
                      </TableCell>
                      <TableCell>{totalb.short?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(totalb.short?.net)}</TableCell>
                      <TableCell>
                        ${fmtMoney(totalb.short?.policy_fee)}
                      </TableCell>
                      <TableCell>${fmtMoney(totalb.short?.total)}</TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>Mid Term</TableCell>
                      <TableCell>{fmtMoney(total.mid?.net_perc)}%</TableCell>
                      <TableCell>{fmtMoney(total.mid?.count_perc)}%</TableCell>
                      <TableCell>{total.mid?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(total.mid?.net)}</TableCell>
                      <TableCell>${fmtMoney(total.mid?.policy_fee)}</TableCell>
                      <TableCell className="separator-year">
                        ${fmtMoney(total.mid?.total)}
                      </TableCell>
                      <TableCell>{fmtMoney(totalb.mid?.net_perc)}%</TableCell>
                      <TableCell>{fmtMoney(totalb.mid?.count_perc)}%</TableCell>
                      <TableCell>{totalb.mid?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(totalb.mid?.net)}</TableCell>
                      <TableCell>${fmtMoney(totalb.mid?.policy_fee)}</TableCell>
                      <TableCell>${fmtMoney(totalb.mid?.total)}</TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>6 Months</TableCell>
                      <TableCell>{fmtMoney(total.long?.net_perc)}%</TableCell>
                      <TableCell>{fmtMoney(total.long?.count_perc)}%</TableCell>
                      <TableCell>{total.long?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(total.long?.net)}</TableCell>
                      <TableCell>${fmtMoney(total.long?.policy_fee)}</TableCell>
                      <TableCell className="separator-year">
                        ${fmtMoney(total.long?.total)}
                      </TableCell>
                      <TableCell>{fmtMoney(totalb.long?.net_perc)}%</TableCell>
                      <TableCell>
                        {fmtMoney(totalb.long?.count_perc)}%
                      </TableCell>
                      <TableCell>{totalb.long?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(totalb.long?.net)}</TableCell>
                      <TableCell>
                        ${fmtMoney(totalb.long?.policy_fee)}
                      </TableCell>
                      <TableCell>${fmtMoney(totalb.long?.total)}</TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>1 Year</TableCell>
                      <TableCell>{fmtMoney(total.long2?.net_perc)}%</TableCell>
                      <TableCell>
                        {fmtMoney(total.long2?.count_perc)}%
                      </TableCell>
                      <TableCell>{total.long2?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(total.long2?.net)}</TableCell>
                      <TableCell>
                        ${fmtMoney(total.long2?.policy_fee)}
                      </TableCell>
                      <TableCell className="separator-year">
                        ${fmtMoney(total.long2?.total)}
                      </TableCell>
                      <TableCell>{fmtMoney(totalb.long2?.net_perc)}%</TableCell>
                      <TableCell>
                        {fmtMoney(totalb.long2?.count_perc)}%
                      </TableCell>
                      <TableCell>{totalb.long2?.policy_count}</TableCell>
                      <TableCell>${fmtMoney(totalb.long2?.net)}</TableCell>
                      <TableCell>
                        ${fmtMoney(totalb.long2?.policy_fee)}
                      </TableCell>
                      <TableCell>${fmtMoney(totalb.long2?.total)}</TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell>Total</TableCell>
                      <TableCell>100.00%</TableCell>
                      <TableCell>100.00%</TableCell>
                      <TableCell>{total.policy_count}</TableCell>
                      <TableCell>${fmtMoney(total.net)}</TableCell>
                      <TableCell>${fmtMoney(total.policy_fee)}</TableCell>
                      <TableCell className="separator-year">
                        ${fmtMoney(total.total)}
                      </TableCell>
                      <TableCell>100.00%</TableCell>
                      <TableCell>100.00%</TableCell>
                      <TableCell>{totalb.policy_count}</TableCell>
                      <TableCell>${fmtMoney(totalb.net)}</TableCell>
                      <TableCell>${fmtMoney(totalb.policy_fee)}</TableCell>
                      <TableCell>${fmtMoney(totalb.total)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(17, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(17, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
